module.exports = __webpack_public_path__ + "static/31-3dbf1c22d1cfda1c96ca6f62a8d1b555.png";